import { render, staticRenderFns } from "./StarsSorted.vue?vue&type=template&id=3f378c80&"
import script from "./StarsSorted.vue?vue&type=script&lang=js&"
export * from "./StarsSorted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StarsSorted.vue"
export default component.exports